import axiosCall from './interceptor';
import URL from '../helper';

const uploadFile = async (formData, whitelist = true) => {
  const url = `${URL.BASE_URL}upload`;
  let response = await axiosCall('post', url, formData, whitelist);
  return response.data;
};

const uploadFontFile = async (formData, whitelist = true) => {
  const url = `${URL.BASE_URL}font/upload`;
  let response = await axiosCall('post', url, formData, whitelist);
  return response.data;
};

export const uploadAttachment = async (file, name) => {
  let form = new FormData();
  form.append('fileType', 'pdf');
  form.append('imageFile', file, name);
  let response = await uploadFile(form, false);
  return response;
};

export const uploadImage = async (file, name) => {
  let form = new FormData();
  form.append('fileType', 'image');
  form.append('imageFile', file, name);
  let response = await uploadFile(form);
  return response;
};

export const uploadFonts = async (file, fileName) => {
  let form = new FormData();
  if (fileName) {
    form.append('fontFile', file, fileName);
  } else {
    form.append('fontFile', file);
  }
  let response = await uploadFontFile(form);
  return response;
};

export const deleteUploads = async payload => {
  const url = `${URL.BASE_URL}deleteImage?id=${payload.id}`;
  let response = await axiosCall('delete', url);
  return response.data;
};

export const dreamAPIGet = async payload => {
  const url = `${URL.IMAGE_GENERATOR_URL}/generateImage`;
  let response = await axiosCall('get', url, { searchText: payload.searchText, width: payload.width, height: payload.height });
  return response.data;
};

export const uploadDKVDesignXML = async (file, name, download = true, type = 'scd') => {
  let form = new FormData();
  form.append('fileType', type);
  form.append('file', file, name);
  // const url = `https://kubedev03.tekclansolutions.com:5000/dkv/generate`;
  const url = 'https://kubedev03.tekclansolutions.com:5050/pseudo/generate';
  let response = await axiosCall('post', url, form, false, false, false, false, true);
  if (response?.status === 200 && download) {
    let file = window.URL.createObjectURL(response.data);
    // window.location.assign(file);

    let fileLink = document.createElement('a');
    fileLink.href = file;
    // suggest a name for the downloaded file
    fileLink.download = name.split('.')[0];
    fileLink.click();

    return response;
  }
  return response;
};
